// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1VASo","label":"Category_label__1NbIY","content":"Category_content__3hewr","header":"Category_header__2HT8Y","location":"Category_location__1icS9"};